import { render, staticRenderFns } from "./PayslipNotification.vue?vue&type=template&id=4bcefdbe&scoped=true"
import script from "./PayslipNotification.vue?vue&type=script&lang=js"
export * from "./PayslipNotification.vue?vue&type=script&lang=js"
import style0 from "./PayslipNotification.vue?vue&type=style&index=0&id=4bcefdbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcefdbe",
  null
  
)

export default component.exports